/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bankc": {
        "nested": {
          "BalanceChangeAttemptResult": {
            "values": {
              "UNKNOWN_RESULT_DO_NOT_USE": 0,
              "BALANCE_CHANGE_SUCCESS": 1,
              "GENERIC_BALANCE_CHANGE_FAILURE": 2,
              "INSUFFICIENT_FUNDS": 3,
              "BALANCE_DISABLED": 4,
              "OVER_LIMIT": 5,
              "EXTERNAL_MONEY_MOVEMENT_FAILURE": 6,
              "RESERVATION_CANCELLED": 7,
              "BLOCKED_FOR_TESTING": 8
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bankc?.nested?.BalanceChangeAttemptResult) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BalanceChangeAttemptResult @ squareup/bankc/result.proto at 8:1
 */
export const BalanceChangeAttemptResult = $root.lookupEnum('squareup.bankc.BalanceChangeAttemptResult').values;